angular.module('MyHippoProducer.Components').directive('pendingPolicyDueDate', function () {
    return {
        restrict: 'E',
        scope: { policy: '<' },
        templateUrl: 'components/pending-policy-due-date/pending-policy-due-date.html',
    };
});
